/**
 * Stops browser default stepping on focused <input type="number"> (mouse wheel,
 * ArrowUp / ArrowDown). Applies app-wide via capture listeners on document.
 * Per-field opt-in to native stepping: data-allow-number-step="true"
 */
export default function installDisableNumberInputStepping() {
  const isNumberInput = el => {
    if (!el || el.nodeName !== 'INPUT') return false
    return (el.getAttribute('type') || '').toLowerCase() === 'number'
  }

  const allowsNativeStep = el => el && el.dataset && el.dataset.allowNumberStep === 'true'

  document.addEventListener(
    'wheel',
    e => {
      const t = e.target
      if (!isNumberInput(t) || allowsNativeStep(t)) return
      if (document.activeElement !== t) return
      e.preventDefault()
    },
    { passive: false, capture: true },
  )

  document.addEventListener(
    'keydown',
    e => {
      const t = e.target
      if (!isNumberInput(t) || allowsNativeStep(t)) return
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault()
      }
    },
    { capture: true },
  )
}
